import { MAGNET_APPEARANCE_PRESETS } from '@sse/shared';
const key = (actor, owner) => actor && owner ? `m5m_style_preference:${encodeURIComponent(actor)}:${encodeURIComponent(owner)}` : null;
export function readStylePreference(actor, owner) {
  try {
    const value = JSON.parse(localStorage.getItem(key(actor, owner)) || 'null');
    return key(actor, owner) && MAGNET_APPEARANCE_PRESETS.some(p => p.id === value?.id) && ['light', 'dark'].includes(value.mode) ? value : null;
  } catch { return null; }
}
export function saveStylePreference(actor, owner, value) {
  if (!key(actor, owner) || !MAGNET_APPEARANCE_PRESETS.some(p => p.id === value?.id) || !['light', 'dark'].includes(value.mode)) return false;
  try { localStorage.setItem(key(actor, owner), JSON.stringify({ id: value.id, mode: value.mode })); return true; } catch { return false; }
}
